module.exports = __WEBPACK_EXTERNAL_MODULE_gui_2D_controls_container__;